import React, { useImperativeHandle } from 'react'
import { Box } from '@mui/material'
import { Snackbar, Slide } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../../redux/slices/Alerts'
import { useNavigate } from 'react-router-dom'

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const Alerts = ({ severity = 'success', stateInitial, children }, ref) => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(stateInitial ?? false)
  const [goRute, setGoRute] = React.useState(null)

  useImperativeHandle(ref, () => ({
    openAlert: value => setOpen(value),
    goRute: value => setGoRute(value),
  }))

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    setOpen(false)
    if (goRute) navigate(goRute)
  }

  React.useEffect(() => {
    if (open) return
    dispatch(setIsStored(null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  if (!open) return null

  return (
    <Box
      component="div"
      sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={7000}
        key="AlertTransitionLeft"
        TransitionComponent={TransitionLeft}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={severity} onClose={handleClose} sx={{ width: '100%' }}>
          {children}
        </Alert>
      </Snackbar>
    </Box>
  )
}
export default React.forwardRef(Alerts)
